const queue = require('./vendor/queue.min');

const composer = {
  version: "0.0.2",
  debug: false,
  currentLevel: 5,
  currentUnit: 'feet',
  levels: {
    feet: {
      // 'level': [[unprotected],[protected]]
      '1' : [[0x000f00, 8,  1], [0x0f0000, 16, 1]],
      '2' : [[0x000f00, 8,  2], [0x0f0000, 16, 2]],
      '3' : [[0x000f00, 8,  3], [0x0f0000, 16, 3]],
      '4' : [[0x000f00, 8,  4], [0x0f0000, 16, 4]],
      '5' : [[0x000f00, 8,  5], [0x0f0000, 16, 5]],
      '6' : [[0x000f00, 8,  6], [0x0f0000, 16, 6]],
      '7' : [[0x000f00, 8,  7], [0x0f0000, 16, 7]],
      '8' : [[0x000f00, 8,  8], [0x0f0000, 16, 8]],
      '9' : [[0x000f00, 8,  9], [0x0f0000, 16, 9]],
      '10' : [[0x000f00, 8,  10], [0x0f0000, 16, 10]],
      '15' : [[0x000f00, 8,  11], [0x0f0000, 16, 11]],
      '30' : [[0x000f00, 8,  12], [0x0f0000, 16, 12]],
      '65' : [[0x000f00, 8,  13], [0x0f0000, 16, 13]],
      '100' : [[0x000f00, 8,  14], [0x0f0000, 16, 14]]
    },

    meters: {
      // 'level': [[unprotected],[protected]]
      '0.5' : [[0x00f000, 12, 1], [0xf00000, 20, 1]],
      '1'   : [[0x00f000, 12, 2], [0xf00000, 20, 2]],
      '1.5' : [[0x00f000, 12, 3], [0xf00000, 20, 3]],
      '2'   : [[0x00f000, 12, 4], [0xf00000, 20, 4]],
      '2.5' : [[0x00f000, 12, 5], [0xf00000, 20, 5]],
      '3'   : [[0x00f000, 12, 6], [0xf00000, 20, 6]],
      '5'   : [[0x00f000, 12, 10], [0xf00000, 20, 10]],
      '6'   : [[0x00f000, 12, 11], [0xf00000, 20, 11]],
      '10'  : [[0x00f000, 12, 12], [0xf00000, 20, 12]],
      '20'  : [[0x00f000, 12, 13], [0xf00000, 20, 13]],
      '30'  : [[0x00f000, 12, 14], [0xf00000, 20, 14]]
    }
  }
};


if (typeof module === "undefined") exports.composer = composer;
else module.exports = composer;

/*
 * The most basic compose operation takes a "stack" of images, e.g.:
 *
 * [
 *  {source: <Image>}
 *  {source: <Image>, alpha: 50}
 * ]
 *
 * To composite groups of images (e.g., to mask one image with another then
 * draw the result onto a lower layer), specify the "source" of the layer as
 * an array of sources:
 *
 * [
 *  {source: <Image>},
 *  {source: [
 *    {source: <Image>, comp: "source-in"},
 *    {source: <image>, comp: "source-out"}
 *  ], alpha: .5}
 * ]
 */
composer.unit = function(unit) {
  if (unit !== 'feet' && unit !== 'meters') return;
  this.currentUnit = unit;
};

composer.level = function(level) {
  this.currentLevel = level;
};

composer.compose = function(stack, canvas, depth) {
  if (!Array.isArray(stack)) {
    throw "stack must be an Array (got: " + typeof stack + ")";
  }
  depth = depth || 0;
  var timerKey = "queue.compose [" + depth + "]";
  if (composer.debug) console.time(timerKey);

  var hasSize = true;
  if (!canvas) {
    canvas = document.createElement("canvas");
    hasSize = false;
  }
  var ctx = canvas.getContext("2d");
  var self = this;
  stack.forEach(function(layer, i) {
    if (!layer || typeof layer !== "object") {
      throw "stack layers must be objects (got " + layer + ")";
    }

    var source = layer.source;
    if (!source) return; // XXX throw error?

    if (source instanceof Array) {
      source = self.compose(source, null, depth + 1);
    }
    if (!hasSize) {
      canvas.width = source.width;
      canvas.height = source.height;
      hasSize = true;
    }

    if (layer.bitmask) {
      var img = new Image;

      var tmpCanvas = document.createElement("canvas");
      tmpCanvas.width = 256;
      tmpCanvas.height = 256;
      var tmpContext = tmpCanvas.getContext("2d");
      tmpContext.drawImage(source, 0, 0);
      var imageData = tmpContext.getImageData(0,0,256,256);

      var level = self.currentLevel;
      var unit = self.currentUnit;

      if (self.currentLevel === 0 && layer.name !== "waterMask") {
        return;
      }

      var protectedMask = self.levels[unit][level][0][0],
        unprotectedMask = self.levels[unit][level][1][0],
        protectedShift = self.levels[unit][level][0][1],
        unprotectedShift = self.levels[unit][level][1][1],
        thresh = self.levels[unit][level][0][2];

      for (var i = 0; i < imageData.data.length; i += 4) {
        var r = imageData.data[i],
          g = imageData.data[i + 1],
          b = imageData.data[i + 2],
          a = imageData.data[i + 3],
          val = (r << 16) + (g << 8) + b;

        var protectedValue = (val & protectedMask) >> protectedShift,
          unprotectedValue =  (val & unprotectedMask) >> unprotectedShift;

        // if ((protectedValue === 0 && unprotectedValue > 0) ||
        //   protectedValue === 0xf) {
        //   // likely NODATA value on the protected layer; use the unprotected
        //   // value instead
        //   protectedValue = unprotectedValue;
        // }

        if (layer.name === "flooding-color") {
          // Checking for a red value of 16 is an artifact of how inland water bodies were encoded
          // when there was no "0" on the map, and the floodmaps indicated inland water bodies were
          // flooded using the same value as the water value available, corresponding to 1ft of flooding.
          // This made no visible difference originally, since the flood layer only had the effect of revealing the blue satellite
          // layer, so there was no difference between "flooded" and "water". We've introduced this difference,
          // but the encoding of the floodmaps still marks inland water with rgb(16, 0, 0). Don't apply flood
          // color to such places.
          if (r === 16) {
            imageData.data[i + 0] = 255;
            imageData.data[i + 1] = 255;
            imageData.data[i + 2] = 255;
          } else {
            imageData.data[i + 0] = 78;
            imageData.data[i + 1] = 218;
            imageData.data[i + 2] = 234;
          }
        } else {
          imageData.data[i + 0] = 255;
          imageData.data[i + 1] = 255;
          imageData.data[i + 2] = 255;
        }

        // check if this pixel is flooded
        if (unprotectedValue <= thresh && protectedValue <= thresh) {
          // fully flooded
          if (layer.name === "flooding-color") {
            if (r === 16) {
              imageData.data[i + 3] = 0;
            } else {
              imageData.data[i + 3] = 63;
            }
          } else {
            imageData.data[i + 3] = 255;
          }
        } else if (unprotectedValue <= thresh) {
          // protected
          if (layer.name === "flooding-color") {
            imageData.data[i + 0] = 0;
            imageData.data[i + 1] = 255;
            imageData.data[i + 2] = 118;
            // imageData.data[i + 0] = 136;
            // imageData.data[i + 1] = 230;
            // imageData.data[i + 2] = 72;
            // imageData.data[i + 3] = 63;
            var px = Math.floor(i / 4),
                row = Math.floor(px / 256),
                col = px % 256;
            if ((row % 2) === 0 && (col % 2) === 0) {
              imageData.data[i + 3] = 192;
            } else {
              imageData.data[i + 3] = 63;
            }
          } else {
            // hatch
            // var px = Math.floor(i / 4),
            //     row = Math.floor(px / 256),
            //     col = px % 256;
            // if ((row % 2) === 0 && (col % 2) === 0) {
            //   imageData.data[i + 3] = 255;
            // } else {
            //   imageData.data[i + 3] = 127;
            // }
            imageData.data[i + 3] = 255;
          }
        } else {
          // not flooded
          imageData.data[i + 3] = 0;
        }
      }

      tmpContext.putImageData(imageData,0,0);
      source = tmpCanvas;
    }

    ctx.globalAlpha = isNaN(layer.alpha) ? 1 : layer.alpha / 100;
    ctx.globalCompositeOperation = layer.comp || "source-over";
    try {
      ctx.drawImage(source, 0, 0);
    } catch (err) {
      // console.warn("composite error:", err, source, source.complete, source.src);
    }
  });
  if (composer.debug) console.timeEnd(timerKey);
  return canvas;
};

/*
 * The composer queue acts like a queue(), but knows low to asynchronously
 * load stack images by URL, e.g.:
 *
 * var stack = [
 *  {url: "foo.png"},
 *  {url: "bar.png", comp: "xor"}
 * ];
 * var canvas = document.createElement("canvas");
 * composer.queue()
 *  .load(stack, function(error, images) {
 *    if (!error) composer.compose(stack, canvas);
 *  });
 *
 * or let the queue handle composing for you (asynchronously):
 *
 * composer.queue()
 *  .compose(stack, canvas);
 *
 * By default, the queue looks for layer urls in the "url" property of each
 * layer object. You can configure how URLs are read from each layer in the
 * stack. null or empty URLs are skipped.
 *
 * var urls = {
 *  "mask": "images/mask.png",
 *  "content": "images/sky.jpg"
 * };
 * var stack = [
 *  {name: "mask", comp: "source-out"},
 *  {name: "content", comp: "source-in"}
 * ];
 * composer.queue()
 *  .url(function(layer) { return urls[layer.name]; })
 *  .compose(stack, canvas);
 */
composer.queue = function(parallelism) {
  var self = this;

  var q = queue(parallelism || Infinity),
    requests = [],
    url = function(layer) {
      return layer.url;
    },
    loadImage = self.load.image,
    enqueue = function(layer, callback) {
      var u = url(layer);
      if (!u) return; // don't load if there's no URL
      var req = loadImage.call(self, u, function(error, image) {
        layer.source = image;
        callback.apply(this, arguments);
      });
      /*
       var req = loadImage(u, function(error, image) {
       layer.source = image;
       callback.apply(this, arguments);
       });
       */
      requests.push(req);
    };

  q.url = function(fn) {
    if (!arguments.length) return url;
    url = functor(fn);
    return q;
  };

  q.load = function(stack, callback) {
    self.eachLayer(stack, function(layer) {
      q.defer(enqueue, layer);
    });
    if (self.debug) console.time("queue.load");
    return q.awaitAll(function(error, images) {
      if (self.debug) console.timeEnd("queue.load");
      callback.call(null, error, stack, images);
      requests = [];
    });
  };

  q.compose = function(stack, canvas) {
    return q.load(stack, function(error, images) {
      if (!error) self.compose(stack, canvas);
      if (callback) callback.call(null, error, stack, images);
    });
  };

  q.abort = function() {
    var req;
    while (requests.length) (req = requests.shift()) && req.abort();
  };

  return q;
};

composer.load = {
  loading: 0
};

/*
 * Load an image URL and execute the callback on load or on error.
 */
composer.load.image = function(url, callback) {
  var self = this;
  if (self.cache.has(url)) {
    setTimeout(function() {
      var image = self.cache.get(url);
      callback.call(null, null, image);
    }, 1);
    return;
  }

  self.load.loading++;

  // Workaround: http://stackoverflow.com/questions/16956295/ie10-and-cross-origin-resource-sharing-cors-issues-with-image-canvas
  var xhr = new XMLHttpRequest();

  xhr.onload = function () {
    var obj_url = URL.createObjectURL(this.response), img = new Image();
    img.onload = function () {
      self.cache.set(url, img);
      self.load.loading--;
      callback.call(null, null, img);
      URL.revokeObjectURL(obj_url);
    };
    img.abort = function() {
      self.load.loading--;
      img.onload = img.onerror = noop;
    };
    img.src = obj_url;
  };

  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.send(null);
};

/*
 * Call a function for each layer in a stack, recursing as it finds nested
 * sources, and return the "flattened" layers as an array.
 */
composer.eachLayer = function(stack, callback) {
  var self = this;
  var layers = [];
  stack.forEach(function(layer) {
    if (layer.source instanceof Array) {
      var sublayers = self.eachLayer(layer.source, callback);
      layers = layers.concat(sublayers);
    } else {
      if (callback) callback.call(null, layer);
      layers.push(layer);
    }
  });
  return layers;
};

/*
 * The composer cache is a static key/value store for keeping images in
 * memory, which drastically speeds up compositing lots of images by URL.
 */
composer.cache = (function() {
  var cache = {},
    values = {},
    keys = [],
    size = 1024;

  cache.has = function(key) {
    return values.hasOwnProperty(key);
  };

  cache.set = function(key, value) {
    if (size <= 0) return value;
    if (!values.hasOwnProperty(key)) {
      keys.push(key);
    }
    values[key] = value;
    trim();
    return value;
  };

  cache.get = function(key) {
    return values[key];
  };

  cache.del = function(key) {
    var index = keys.indexOf(key),
      value = values[key];
    delete values[key];
    keys.splice(index, 1);
    return value;
  };

  cache.length = function() {
    return keys.length;
  };

  cache.size = function(len) {
    if (!arguments.length) return size;
    size = len;
    trim();
    return cache;
  };

  cache.flush = function() {
    keys = [];
    values = {};
    return cache;
  };

  function trim() {
    while (keys.length > size) {
      var key = keys.shift();
      delete values[key];
    }
    return cache;
  }

  return cache;
})();

composer.cache.emptyUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";

function functor(n) {
  return (typeof n === "function") ? n : function() { return n; };
}

function noop() {}
